/**
 * ============================================================================
 * User 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义模块相关的所有枚举类型
 * - 包含：UserStatus
 * 
 * 📖 对应后端：
 * - Model: backend/app/Models/User.php
 * - Migration: backend/database/migrations/0001_01_01_000000_create_users_table.php
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 业务新增状态/类型时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/database/migrations/0001_01_01_000000_create_users_table.php
 * 2. 找到 status 字段的定义和注释
 * 3. 检查枚举值、名称是否与后端一致
 * 4. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/user/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * 用户状态
 */
export enum UserStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 正常 */
  ACTIVE = 1,
}

